export default function Marquee({ children, duration = 40, className = "" }) {
  return (
    <div className={`marquee ${className}`}>
      <div className="marquee-track" style={{ animationDuration: `${duration}s` }}>
        <div className="marquee-seg">{children}</div>
        <div className="marquee-seg" aria-hidden="true">
          {children}
        </div>
      </div>
    </div>
  );
}
